<template>
  <d2-container>
    <template slot="header">
      <el-select
        @keyup.enter.native="getList"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getList" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
      v-permission:function="['fissionManger:btn_add']"
    >添加</el-button>
    <el-table
      v-loading="listLoading"
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="活动标题">
        <template slot-scope="scope">
          <span>{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="活动名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间">
        <template slot-scope="scope">
          <span>{{scope.row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间">
        <template slot-scope="scope">
          <span>{{scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未开始</span>
          <span v-if="scope.row.status == 1">进行中</span>
          <span v-if="scope.row.status == 2">已结束</span>
          <span v-if="scope.row.status == 3">已关闭</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="success"
            @click="getEdit(scope.row.id)"
            v-permission:function="['fissionManger:btn_edit']"
            class="getEdits"
          >编辑</el-button>
          <span v-permission:function="['fissionManger:btn_put']">
            <el-button
              size="small"
              type="primary"
              v-if="scope.row.status == 3"
              @click="getPut(scope.row.id)"
            >上架</el-button>
          </span>
          <span v-permission:function="['fissionManger:btn_off']">
            <el-button
              size="small"
              type="primary"
              v-if="scope.row.status != 3"
              @click="getOff(scope.row.id)"
            >下架</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import {
  getFissionList,
  getFissiondown,
  getFissionup
} from '@/api/demo/fission/index'
export default {
  name: 'fissionManger',
  data () {
    return {
      fissionManger_btn_add: false,
      fissionManger_btn_edit: false,
      fissionManger_btn_put: false,
      fissionManger_btn_off: false,
      statusList: [
        { id: 0, name: '未开始' },
        { id: 1, name: '进行中' },
        { id: 2, name: '已结束' },
        { id: 3, name: '已关闭' }
      ],
      list: [],
      tableKey: 0,
      listLoading: false,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        status: ''
      },
      total: 0
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList (val) {
      let that = this
      if (typeof val !== 'object') {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      that.listLoading = true
      getFissionList(that.listQuery).then(res => {
        that.list = res.records
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    getAdd () {
      this.$router.push({
        path: '/demo/fission/editFission'
      })
    },
    getEdit (id) {
      this.$router.push({
        path: './fission/editFission',
        query: {
          id: id
        }
      })
    },
    // 上架
    getPut (id) {
      let that = this
      getFissionup(id).then(res => {
        that.$notify({
          title: '成功',
          message: '下架成功',
          type: 'success',
          duration: 2000
        })
        that.getList(that.listQuery.currentPage)
      })
    },
    // 下架
    getOff (id) {
      let that = this
      getFissiondown(id).then(res => {
        that.$notify({
          title: '成功',
          message: '下架成功',
          type: 'success',
          duration: 2000
        })
        that.getList(that.listQuery.currentPage)
      })
    }
  }
}
</script>
<style scoped>
.getEdits{
  margin-right: 10px;
}
</style>
